import React, { useMemo } from 'react';
import { useEnabledGroupTypes } from './hooks/useEnabledGroupTypes';
import { useSmartSuggestionSetting } from './hooks/useSmartSuggestionSetting';
import { SmartSuggestionPage } from './SmartSuggestionPage';
import { StartEndSettingsPageSkeleton } from './StartEndSettingsPageSkeleton';
export const SmartSuggestionLanding: React.FC = () => {
  const {
    data: settingsData,
    loading: settingsLoading
  } = useSmartSuggestionSetting();
  const { data, loading } = useEnabledGroupTypes();
  const enabledGroupTypes = useMemo(
    () => data?.enabledGroupTypes?.items || [],
    [data]
  );
  const settings = useMemo(
    () => settingsData?.getSmartSuggestionSettings.settings || [],
    [settingsData]
  );
  if (loading || settingsLoading) {
    return <StartEndSettingsPageSkeleton />;
  }

  return (
    <div data-testid="SmartSuggestionLanding">
      <SmartSuggestionPage
        enabledGroupTypes={enabledGroupTypes}
        settings={settings}
      />
    </div>
  );
};
